<template>
  <v-dialog v-model="dialog_open" persistent max-width="1300" min-height="455px">
    <v-card-text style="background-color: #fff">
      <v-card-title
        class="py-3 white--text"
        value="tab-1"
      >
      <span class="text-333333 font-20 w-700" style="align-self: center;">รายการจุดตรวจ</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog_open = false" style="text-align: right">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-card-title>
      <div class="px-3">
        <v-row class="py-0 px-5 mt-0 pb-3">   
          <v-col class="d-flex py-0" cols="12">
            <span class="text-313B41 w-600 font-16">ข้อมูลจุดตรวจ</span>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="addServiceCheckpoint(), scrollToBottom()" id="btn" icon>
                  <v-icon color="#00A99D">mdi-plus-box</v-icon>
                </v-btn>
              </template>
              <span>เพิ่มจุดตรวจ</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <div class="pl-8 pt-3 pb-3" style="overflow: auto; max-height: 400px;">
          <v-row class="pt-0 pb-5 mx-0" v-for="(item, index) in checkpoint_list" :key="index">
            <v-col cols="11" style="border: 1px solid #00A99D; border-radius: 10px; padding: 15px 0px;" :id="checkpoint_list.length - index == 1 ? 'content' : index">
              <v-row class="px-5 mt-0 pb-0">
                <v-col cols="12" class="mt-0 pb-0 pt-0">
                  <span class="text-313B41 w-600 font-16">จุดตรวจที่: {{ index+ 1 }}</span>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    solo
                    dense
                    hide-details="auto"
                    placeholder="กรอกชื่อจุดตรวจ"
                    v-model="checkpoint_list[index].checkpoint_name"
                    :rules="rule_name"
                  ></v-text-field>    
                </v-col>   
              </v-row>
            </v-col>
            <v-col cols="auto" align-self="center" class="pl-0 pt-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="deleteCheckpoint(index)" icon>
                    <v-icon color="#F5222D">mdi-minus-box</v-icon>
                  </v-btn>
                </template>
                <span>ลบ จุดตรวจ</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </div>
        <v-card-actions>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" sm="6" style="text-align: end" >
              <v-btn
                style="border-radius: 26px"
                color="#F5222D"
                dark
                outlined
                width="50%"
                height="48px"
                @click="close"
              >
                ยกเลิก
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                style="border-radius: 26px"
                color="#00A99D"
                dark
                width="50%"
                height="48px"
                :loading="save_dialog"
                @click="
                  confirmEdit();
                "
              >
                บันทึก
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
    </v-card-text>
    <Sweetdialog ref="sweetDialog" @submit="sweetSubmit" />
  </v-dialog>
</template>

<script>
import Sweetdialog from '../Sweetdialog.vue'

export default {
  components: {
    Sweetdialog,
  },
  data: () => ({
    dialog_open: false,
    save_dialog: false,
    biz_id: "",
    checkpoint_list: [
      {
        checkpoint_id: "",
        checkpoint_name: "",
        checkpoint_no: "1",
        created_by: "",
      }
    ],
    rule_name: [(v) => !!v || "กรุณากรอกชื่อจุดตรวจ"],
  }),
  watch: {
    checkpoint_list(vul) {
      // console.log("2222 checkpoint_list", vul);
      if(vul.length != 0) {
        this.scrollBottom()
      }
    },
    // toptop(vul) {
    //   console.log("2222 toptop", vul);
    // }
  },
  computed: {
    // toptop() {
    //   return document.querySelector('#content');
    // }
  },
  methods: {
    // onScroll () {
    //   this.offsetTop = this.target.scrollTop
    // },
    scrollToBottom(){
      let btn = document.querySelector('#btn');
      let el = document.querySelector('#content');
      btn.addEventListener('click', function () {
        el.scrollIntoView(true);
      });
    },
    scrollBottom(){
      setTimeout(() => {
        let element = document.querySelector('#content');
        this.offsetTop = element.scrollIntoView(true);   
      }, 100);
    },
    async openDialog(page, biz_id) {
      console.log("openDialog page", page);
      console.log("openDialog biz_id", biz_id);
      this.biz_id = biz_id;
      await this.getCheckpoint(biz_id)
      this.dialog_open = true;
    },
    async getCheckpoint(biz_id) {
      try {
        console.log("getCheckpoint");
        const params = new URLSearchParams();
        params.append("biz_id", biz_id);
        this.checkpoint_list = []
        await this.axios.get(process.env.VUE_APP_BACKEND_URL+`/v1/get/checkpoint?${params}`).then( async (res) => {
          console.log("/v1/get/checkpoint:", res);
          if (res.data.result == "success" && res.data.code == 200) {
            if( res.data.data.length !== 0) {
              this.checkpoint_list = res.data.data
                // await this.scrollBottom()
              // this.checkpoint_list = res.data.data
              // setTimeout(() => {
               
              // }, 1500);
              
            }
          } else {
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ไม่สามารถเเสดงข้อมูลจุดตรวจได้</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
            };
            this.$refs.sweetDialog.open(data);
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async addServiceCheckpoint() {
      await this.checkpoint_list.push({
        checkpoint_id: "",
        checkpoint_name: "",
        checkpoint_no: "",
        created_by: "",
      });
    },
    deleteCheckpoint(index) {
      console.log("deleteCheckpoint");
      if (this.checkpoint_list.length === 1) {
            this.checkpoint_list = [
              {
                checkpoint_id: "",
                checkpoint_name: "",
                checkpoint_no: "1",
                created_by: "",
              }
            ]
          } else {
            this.checkpoint_list.splice(index, 1);
          }
    },
    async confirmEdit() {
      console.log("confirmEdit");
      const data = {
          title: "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ท่านยืนยันข้อมูลหรือไม่</b></span>",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText: "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
          returnEmit: 'confirm',
        }
        this.$refs.sweetDialog.open(data)

    },
    async sweetSubmit() {
      try {
        this.save_dialog = true;
        console.log("sweetSubmit");
        var send_checkpoint_list = []
        if(this.checkpoint_list.length !== 0) {
          await this.checkpoint_list.forEach(async (ele, index) => {
            if(ele.checkpoint_name !== "") {
              await send_checkpoint_list.push({
                checkpoint_id: ele.checkpoint_id,
                checkpoint_name: ele.checkpoint_name,
                checkpoint_no: index + 1,
                created_by: "",
              })
            }
            
          })
        }
        
        var body = {
          biz_id: this.biz_id,
          checkpoint_list: send_checkpoint_list
        }
        const params = new URLSearchParams();
        params.append("biz_id", this.biz_id);
        await this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/add/checkpoint`,
        body,
        ).then((res) => {
          console.log("/v1/add/checkpoint:", res);
          if (res.data.result == "success" && res.data.code == 200) {
            this.save_dialog = false;
            this.dialog_open = false;
            this.$emit("update");
          } else {
            this.save_dialog = false;
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลจุดตรวจไม่สำเร็จ</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
            };
            this.$refs.sweetDialog.open(data);
          }
        })
      } catch(err) {
        this.save_dialog = false;
        console.log(err);
      }
      
    },
    close() {
      this.dialog_open = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
::v-deep .v-label {
  font-size: 20em;
}
::v-deep .v-label--active {
  font-size: 20em;
  font-weight: bold;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .v-input__append-outer{
  margin-top: 0px !important;
}
</style>
